import { IMarker, IFlatMarker } from '../marker.model';
import { MarkerUtil } from '../../utilities/marker.util';

/**
 * Marker class - Implements marker interface with utility method delegates
 */
export class Marker implements IMarker {
  // Properties from IMarker interface
  public id: any;
  public sensorID!: number;
  public relativeX!: number;
  public relativeY!: number;
  public relativeDiameter!: number;
  public active = false;
  public label!: string;
  public selected = true;
  public circular = true;
  public relativeWidth!: number;
  public relativeHeight!: number;

  // Getters delegating to utility functions
  public getAbsoluteX(width: number): number {
    return MarkerUtil.getAbsoluteX(this, width);
  }

  public getAbsoluteY(height: number): number {
    return MarkerUtil.getAbsoluteY(this, height);
  }

  public getClientX(
    client_w: number,
    client_h: number,
    nat_w: number,
    nat_h: number,
    offset = 0
  ): number {
    return MarkerUtil.getClientX(this, client_w, client_h, nat_w, nat_h, offset);
  }

  public getClientY(
    client_w: number,
    client_h: number,
    nat_w: number,
    nat_h: number,
    offset = 0
  ): number {
    return MarkerUtil.getClientY(this, client_w, client_h, nat_w, nat_h, offset);
  }

  public getAbsoluteHeight(height: number): number {
    return MarkerUtil.getAbsoluteHeight(this, height);
  }

  public getAbsoluteWidth(width: number): number {
    return MarkerUtil.getAbsoluteWidth(this, width);
  }

  public getAbsoluteDiameter(width: number): number {
    return MarkerUtil.getAbsoluteDiameter(this, width);
  }

  public setAbsoluteX(x: number, width: number): void {
    MarkerUtil.setAbsoluteX(this, x, width);
  }

  public setAbsoluteY(y: number, height: number): void {
    MarkerUtil.setAbsoluteY(this, y, height);
  }

  public setClientX(
    x: number,
    client_w: number,
    client_h: number,
    nat_w: number,
    nat_h: number
  ): void {
    MarkerUtil.setClientX(this, x, client_w, client_h, nat_w, nat_h);
  }

  public setClientY(
    y: number,
    client_w: number,
    client_h: number,
    nat_w: number,
    nat_h: number
  ): void {
    MarkerUtil.setClientY(this, y, client_w, client_h, nat_w, nat_h);
  }

  public setAbsoluteDiameter(d: number, width: number): void {
    MarkerUtil.setAbsoluteDiameter(this, d, width);
  }

  public static getDeselectedEmptyMarker(): Marker {
    const m = new Marker();
    Object.assign(m, MarkerUtil.getDeselectedEmptyMarker());
    return m;
  }

  constructor(
    sensorID = -1,
    label = '',
    relativeX = 0.5,
    relativeY = 0.5,
    relativeDiameter = 0.1,
    selected = true,
    width = 0,
    height = 0,
    relativeWidth = 0,
    relativeHeight = 0
  ) {
    const markerData = MarkerUtil.createMarker(
      sensorID,
      label,
      relativeX,
      relativeY,
      relativeDiameter,
      selected,
      width,
      height,
      relativeWidth,
      relativeHeight
    );
    Object.assign(this, markerData);
  }
}

export class FlatMarker implements IFlatMarker {
  sensorId!: number;
  x!: number;
  y!: number;
  label?: string;
}

export interface EquipmentPhoto {
  defaultImage: string | null;
  useDefaultImage: boolean;
  imagePreview: string; // data URL or base64
  imageFile: File | null; // actual file
  imageWidth: number | null;
  imageHeight: number | null;
  markers: Marker[];
}
